export default function createBinaryExpression(nodeType, left, right) {
    return { nodeType, left, right };
}
